export default __webpack_public_path__ + "static/media/strech-yarn-pdp.3b31e333.png";